
export default function CoreCognition() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-20">
          我们构建的是"结构化合规能力"
        </h2>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-4">
            <div className="text-4xl font-bold text-gray-900 leading-tight">
              出口业务的复杂性
              <br />
              来自"数据关系"
              <br />
              <span className="bg-gradient-to-r from-[#0D9488] to-[#14B8A6] bg-clip-text text-transparent">
                而非"操作动作"
              </span>
            </div>
            <p className="text-gray-500 text-base leading-relaxed pt-2">
              星贸云从数据结构与关系模型出发，构建可复用、可审计的合规管理体系。
            </p>
          </div>

          <div className="space-y-4">
            {[
              {
                title: '多源数据之间缺乏统一结构',
                desc: '平台、收款、报关、单证等数据源格式不一，难以形成统一管理视图',
              },
              {
                title: '规则判断依赖人工经验',
                desc: '缺乏系统化的规则引擎，业务判断高度依赖个人经验积累',
              },
              {
                title: '资料留存未形成链路模型',
                desc: '单证与数据分散存储，缺乏版本管理与关系追溯能力',
              },
            ].map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-4 p-6 rounded-xl border border-gray-100 bg-gray-50 hover:border-[#14B8A6]/40 hover:bg-[#F0FDFA] transition-all"
              >
                <div className="w-2 h-2 rounded-full bg-[#14B8A6] mt-2 flex-shrink-0"></div>
                <div>
                  <h3 className="text-base font-semibold text-gray-800 mb-1">{item.title}</h3>
                  <p className="text-sm text-gray-500">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
